import { getRequest, postRequest } from 'api/apiUtils'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import UserActionTypes from 'redux/user/user-types'
import * as limitedTokensActions from './limitedTokens-actions'
import LimitedTokensActionTypes from './limitedTokens-types'

function* signInSuccess() {
    yield put(limitedTokensActions.startFetchAvailableLimitedTokens())
}

export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, signInSuccess)
}

function* startFetchAvailableLimitedTokens() {
    try {
        const { data } = yield getRequest('/user/tokens/available')
        yield put(limitedTokensActions.successFetchAvailableLimitedTokens(data))
    } catch (err) {
        yield put(limitedTokensActions.failureFetchAvailableLimitedTokens({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartFetchAvailableLimitedTokens() {
    yield takeLatest(LimitedTokensActionTypes.START_FETCH_AVAILABLE_LIMITED_TOKENS, startFetchAvailableLimitedTokens)
}

function* startBuyLimitedTokens({ payload: { value, currencyCode, walletId, buyAccountId } }) {
    try {
        yield postRequest(`/user/tokens/${walletId}/buy`, { buyAccountId, buyAmount: { value, currencyCode } })
        yield put(limitedTokensActions.successBuyLimitedTokens())
    } catch (err) {
        yield put(limitedTokensActions.failureBuyLimitedTokens({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartBuyLimitedTokens() {
    yield takeLatest(LimitedTokensActionTypes.START_BUY_LIMITED_TOKENS, startBuyLimitedTokens)
}

function* startSellLimitedTokens({ payload: { walletId, sellAccountId, currencyCode, value } }) {
    try {
        yield postRequest(`/user/tokens/${walletId}/sell`, { targetAccountId: sellAccountId, limitedTokenAmount: { value, currencyCode } })
        yield put(limitedTokensActions.successSellLimitedTokens())
    } catch (err) {
        yield put(limitedTokensActions.failureSellLimitedTokens({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartSellLimitedTokens() {
    yield takeLatest(LimitedTokensActionTypes.START_SELL_LIMITED_TOKENS, startSellLimitedTokens)
}

function* startGetSellLimitedTokensFee({ payload: { id, toCurrency, amount } }) {
    try {
        const { data } = yield postRequest(`/user/tokens/${id}/sell/fee`, { toCurrency, amount })
        yield put(limitedTokensActions.successGetSellLimitedTokensFee(data))
    } catch (err) {
        yield put(limitedTokensActions.failureGetSellLimitedTokensFee({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartGetSellLimitedTokensFee() {
    yield takeLatest(LimitedTokensActionTypes.START_GET_SELL_LIMITED_TOKENS_FEE, startGetSellLimitedTokensFee)
}

function* startGetBuyLimitedTokensFee({ payload: { id, currencyCode, value } }) {
    try {
        const { data } = yield postRequest(`/user/tokens/${id}/buy/fee`, { currencyCode, value })
        yield put(limitedTokensActions.successGetBuyLimitedTokensFee(data))
    } catch (err) {
        yield put(limitedTokensActions.failureGetBuyLimitedTokensFee({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartGetBuyLimitedTokensFee() {
    yield takeLatest(LimitedTokensActionTypes.START_GET_BUY_LIMITED_TOKENS_FEE, startGetBuyLimitedTokensFee)
}

function* startTransferLimitedTokens({ payload: { receiver, comment, verificationCode, amount, id } }) {
    try {
        yield postRequest(`/user/tokens/${id}/transfer`, { receiver, comment, verificationCode, amount })
        yield put(limitedTokensActions.successTransferLimitedTokens())
    } catch (err) {
        yield put(limitedTokensActions.failureTransferLimitedTokens({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartTransferLimitedTokens() {
    yield takeLatest(LimitedTokensActionTypes.START_TRANSFER_LIMITED_TOKENS, startTransferLimitedTokens)
}

function* startWithdrawLimitedTokens({ payload: { verificationCode, amount, externalWalletAddress, id, tag } }) {
    try {
        yield postRequest(`/user/tokens/${id}/withdraw`, { verificationCode, amount, externalWalletAddress, tag })
        yield put(limitedTokensActions.successWithdrawLimitedTokens())
    } catch (err) {
        yield put(limitedTokensActions.failureWithdrawLimitedTokens({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartWithdrawLimitedTokens() {
    yield takeLatest(LimitedTokensActionTypes.START_WITHDRAW_LIMITED_TOKENS, startWithdrawLimitedTokens)
}

function* startGetLimitedTokenDetails({ payload: id }) {
    try {
        const { data } = yield getRequest(`/user/tokens/${id}`)
        yield put(limitedTokensActions.successGetLimitedTokenDetails(data))
    } catch (err) {
        yield put(limitedTokensActions.failureGetLimitedTokenDetails({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartGetLimitedTokenDetails() {
    yield takeLatest(LimitedTokensActionTypes.START_GET_LIMITED_TOKEN_DETAILS, startGetLimitedTokenDetails)
}

function* startFetchLimitedTokenHotWalletFee({ payload: { id, amount, address, tag } }) {
    try {
        const { data } = yield postRequest(`/user/tokens/${id}/withdraw/hot-wallet-fee`, { amount, externalWalletAddress: address, tag })
        yield put(limitedTokensActions.successFetchLimitedTokenHotWalletFee(data))
    } catch (err) {
        yield put(limitedTokensActions.failureFetchLimitedTokenHotWalletFee({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartFetchLimitedTokenHotWalletFee() {
    yield takeLatest(LimitedTokensActionTypes.START_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE, startFetchLimitedTokenHotWalletFee)
}

function* startRedeemLimitedTokens({ payload: { id, amount, addressNo, verificationCode } }) {
    try {
        const { data } = yield postRequest(`/user/tokens/${id}/redeem`, { amount, addressNo, verificationCode })
        yield put(limitedTokensActions.successRedeemLimitedTokens({ amount, transferNo: data.no }))
    } catch (err) {
        yield put(limitedTokensActions.failureRedeemLimitedTokens({ errorMessage: err?.response?.data?.errors }))
    }
}

export function* onStartRedeemLimitedTokens() {
    yield takeLatest(LimitedTokensActionTypes.START_REDEEM_LIMITED_TOKENS, startRedeemLimitedTokens)
}

export function* limitedTokensSaga() {
    yield all([
        call(onSignSuccess),
        call(onStartFetchAvailableLimitedTokens),
        call(onStartGetSellLimitedTokensFee),
        call(onStartGetBuyLimitedTokensFee),
        call(onStartSellLimitedTokens),
        call(onStartBuyLimitedTokens),
        call(onStartTransferLimitedTokens),
        call(onStartWithdrawLimitedTokens),
        call(onStartGetLimitedTokenDetails),
        call(onStartFetchLimitedTokenHotWalletFee),
        call(onStartRedeemLimitedTokens),
    ])
}
